export default class FindInvoiceController {
  constructor(ContentService, isMobile, moment, ProfilePermissionsService, $uibModal) {
    this.service = ContentService;
    this.isMobile = isMobile;
    this.moment = moment;
    this.permissionsService = ProfilePermissionsService;
    this.modal = $uibModal;
  }

  $onInit() {
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;
    this.date =  undefined;

    this.invoice = '';
    this.invoices = [];
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getInvoices() {
    return this.invoices.map(inv => {
      var newInv = angular.copy(inv, {});
      newInv.date = this.moment(newInv.date).format('DD/MM/YYYY');
      return newInv;
    });
  }

  findInvoice() {
    this.subscriptions.push(
      this.service.findInvoice({
        date: this.date.format(),
        bill_id: this.invoice,
      }).subscribe(
        (invoices) => this.invoices = invoices,
        (err) => console.log(err)
      )
    );
  }

  getDiscount(item) { return item.discount; }
  getPax(item) { return item.pax; }
  getTotal(item) { return item.total; }
  getExtraTip(item) { return item.extra_tip; }
  getTax10(item) { return item.tax10; }
  getTax16(item) { return item.tax16; }

  openBillDetails(invoiceId) {
    var that = this;
    if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')){
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'invoice-details-template.html',
        appendClassName: 'ngdialog-theme-plain',
        controller: ($scope, $uibModalInstance, AccountInformationService) => {
          "ngInject";

          $scope.invoice = {};
          $scope.orders = [];
          $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
          that.subscriptions.push(
            that.service.getInvoice(invoiceId).subscribe(
              (invoice) => $scope.invoice = invoice,
              (error) => console.log("Error while getting the invoice")
            )
          );

          $scope.getOrders = () => {
            if ($scope.orders.length <= 0) {
              that.subscriptions.push(
                that.service.getOrders(invoiceId).subscribe(
                  (orders) => $scope.orders = orders,
                  (error) => console.log("Error while getting the orders")
                )
              );
            }
          };

          that.subscriptions.push(
            AccountInformationService.getAccountInfo().subscribe(
              (resp) => {
                $scope.account = resp;
              }
            )
          );
          
          $scope.fetchDetails = (order) => {
            if (!order.details || order.details.length <= 0) {
              that.subscriptions.push(
                that.service.getOrderDetails(invoiceId, order.id).subscribe(
                  (details) => {
                    order.details = details;
                    $scope.displayingOrder = order;
                  },
                  (error) => console.log("Error while getting the details for this order")
                )
              );
            }
          };

          $scope.printToCart = (printSectionId) => {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            const styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();            
            const styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
            popupWinindow.document.write(`<html><head><title>Imprimir factura #${$scope.invoice.number}</title><style>${styleprint.innerHTML}</style><style>${styleprintBootstrap.innerHTML}</style></head><body onload="window.print()">${innerContents}</html>`);
            popupWinindow.document.close();
          };
          
          $scope.closeThisDialog = () => $uibModalInstance.close();
        }
      });
    }
  }
}

 FindInvoiceController.$inject = ['ContentService', 'isMobile', 'moment', 'ProfilePermissionsService', '$uibModal'];


// WEBPACK FOOTER //
// ./src/app/pages/find-invoice/find-invoice.controller.js